import { createSelector } from '@ngrx/store';
import { State } from '../../reducers';
import EnvironmentConfigState, { initialState as environmentConfigInitialState } from './environment-config.reducer';

export const getEnvironmentConfigState = (state: State) => state.environmentConfig ?? environmentConfigInitialState;

export const selectShortEnvName = createSelector(getEnvironmentConfigState, (state: EnvironmentConfigState) =>
  state.environment?.substring(0, 3)
);

export const selectIsNotProdEnv = createSelector(getEnvironmentConfigState, (state: EnvironmentConfigState) =>
  state.environment !== 'production'
);
